document.addEventListener('DOMContentLoaded', function () {
	var paragraphLinks = document.querySelectorAll('p a');
	paragraphLinks.forEach(function (link) {
		if (link.href.includes('youtube.com') || link.href.includes('youtu.be')) {
			var videoId = getYouTubeVideoId(link.href);
			if (videoId !== '') {
				var iframeSrc = 'https://www.youtube.com/embed/' + videoId;
				var iframe = document.createElement('iframe');
				iframe.width = '560';
				iframe.height = '315';
				iframe.src = iframeSrc;
				iframe.frameborder = '0';
				iframe.allowfullscreen = true;
				link.parentNode.replaceChild(iframe, link);
			}
		}
	});

	function getYouTubeVideoId(url) {
		var videoId = '';
		if (url.includes('youtube.com')) {
			videoId = url.split('v=')[1];
			var ampersandPosition = videoId.indexOf('&');
			if (ampersandPosition !== -1) {
				videoId = videoId.substring(0, ampersandPosition);
			}
		} else if (url.includes('youtu.be')) {
			videoId = url.split('/').pop();
		}
		return videoId;
	}
});
